import React, { forwardRef } from 'react';

// Off-screen card rendered to an image for sharing (inline styles: html2canvas-safe).
const BADGE = {
  won: { bg: '#10B98133', fg: '#6EE7B7', bd: '#10B981', label: '✅' },
  lost: { bg: '#EF444433', fg: '#FCA5A5', bd: '#EF4444', label: '❌' },
  live: { bg: '#FACC1526', fg: '#FDE047', bd: '#FACC15', label: 'IN CORSO' },
  pending: { bg: '#FFFFFF14', fg: '#E5E7EB', bd: '#FFFFFF40', label: 'DA GIOCARE' },
  unverifiable: { bg: '#FFFFFF0D', fg: '#9CA3AF', bd: '#FFFFFF26', label: 'DA VERIFICARE' },
  void: { bg: '#FFFFFF0D', fg: '#9CA3AF', bd: '#FFFFFF26', label: 'RINVIATA' },
};
const STARTED = (s) => s && s !== 'NS' && s !== 'TBD';

const ShareRow = ({ p }) => {
  const b = BADGE[p.state] || BADGE.pending;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', borderBottom: '1px solid #FFFFFF10', background: p.state === 'won' ? '#10B98112' : p.state === 'lost' ? '#EF444412' : 'transparent' }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: '#fff', fontSize: 14, fontWeight: 600, lineHeight: '20px' }}>
          {p.home_team} - {p.away_team}
        </div>
        <div style={{ marginTop: 5, display: 'inline-flex', alignItems: 'center', height: 22, padding: '0 8px 9px', borderRadius: 6, border: `1px solid ${b.bd}`, background: b.bg, color: b.fg, fontSize: 11, fontWeight: 800, textTransform: 'uppercase' }}>
          {p.market}
        </div>
      </div>
      {STARTED(p.status) && <div style={{ color: '#fff', fontSize: 16, fontWeight: 800 }}>{p.score_home ?? 0}-{p.score_away ?? 0}</div>}
      <div style={{ width: 74, textAlign: 'right', color: b.fg, fontSize: p.state === 'won' || p.state === 'lost' ? 20 : 10, fontWeight: 800 }}>{b.label}</div>
    </div>
  );
};

export const MySelectionShareCard = forwardRef(({ picks }, ref) => {
  const won = picks.filter((p) => p.state === 'won').length;
  const lost = picks.filter((p) => p.state === 'lost').length;
  const open = picks.length - won - lost;
  return (
    <div ref={ref} style={{ width: 430, background: '#141414', fontFamily: 'Manrope, Arial, sans-serif', paddingBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '18px 16px 12px' }}>
        <img src="/logo192.png" alt="" style={{ width: 34, height: 34, borderRadius: 8 }} />
        <div>
          <div style={{ color: '#F5A623', fontSize: 18, fontWeight: 900, letterSpacing: 1 }}>RVINCENTE</div>
          <div style={{ color: '#9CA3AF', fontSize: 11 }}>La mia selezione · live</div>
        </div>
      </div>
      <div style={{ margin: '0 16px 12px', padding: '0 12px 6px', height: 42, display: 'flex', alignItems: 'center', borderRadius: 12, background: '#F5A6231A', border: '1px solid #F5A62366', color: '#fff', fontSize: 14, fontWeight: 800 }}>
        {open === 0 ? `🏁 ${won} su ${picks.length} eventi andati a segno` : `✅ ${won}  ·  ❌ ${lost}  ·  ⏳ ${open} in corso`}
      </div>
      <div style={{ margin: '0 16px', borderRadius: 12, overflow: 'hidden', background: '#1E1E1E' }}>
        {picks.map((p) => <ShareRow key={p.fixture_id} p={p} />)}
      </div>
      <div style={{ marginTop: 14, textAlign: 'center', color: '#9CA3AF', fontSize: 11 }}>
        Segui le tue selezioni live con l'app <span style={{ color: '#F5A623', fontWeight: 800 }}>RVINCENTE</span>
      </div>
    </div>
  );
});

export default MySelectionShareCard;
